import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App.tsx';
import ChunkLoadErrorBoundary from './components/ChunkLoadErrorBoundary';
import { setupChunkLoadRecovery } from './utils/chunkLoadRecovery';

setupChunkLoadRecovery();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ChunkLoadErrorBoundary>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ChunkLoadErrorBoundary>
  </StrictMode>,
);
